import wire from '../wire';
import template from './extended-test.html';
import ExtendedTestController from './extended-test-controller';

let module = wire(
  'extended-test',
  template,
  ExtendedTestController,
  'ExtendedTestController',
  '/extended-test'
);

export default module;



// WEBPACK FOOTER //
// ./app/pages/extended-test/_index.js